import React from "react";
import {
  Tabs,
  Tab,
  Box,
  MenuItem,
  Select,
  Typography,
  SvgIcon,
  Popover,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../pages/reports/Datepicker.css";
import arrowLeft from "../../../src/assests/images/arrow-left.svg";
import arrowRight from "../../../src/assests/images/arrow-right.png";
import doubleArrowLeft from "../../../src/assests/images/double-arrow-left.svg";
import doubleArrowRight from "../../../src/assests/images/double-arrow-right.svg";

function DashboardDatePicker() {
  const [value, setValue] = React.useState(0);
  const [location, setLocation] = React.useState("All Locations");
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [startDate, setStartDate] = React.useState<Date | null>(new Date());
  const [endDate, setEndDate] = React.useState<Date | null>(null);

  const popoverRef = React.useRef<HTMLDivElement>(null); // Ref for the popover
  const datePickerRef = React.useRef<HTMLDivElement>(null); // Ref for the DatePicker container

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (newValue === 4) {
      setAnchorEl(event.currentTarget as HTMLElement); // Open calendar popover
    } else {
      setValue(newValue); // Update tab for non-calendar tabs
    }
  };

  const handleLocationChange = (event: any) => {
    setLocation(event.target.value);
  };

  const handleDateChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const handleClose = (event: MouseEvent) => {
    // Close popover only if click is outside popover or DatePicker
    if (
      popoverRef.current &&
      !popoverRef.current.contains(event.target as HTMLElement) &&
      datePickerRef.current &&
      !datePickerRef.current.contains(event.target as HTMLElement)
    ) {
      setAnchorEl(null); // Close popover
    }
  };

  React.useEffect(() => {
    document.addEventListener("mousedown", handleClose);
    return () => document.removeEventListener("mousedown", handleClose);
  }, [anchorEl]);

  const isPopoverOpen = Boolean(anchorEl);

  return (
    <div>
      <Box
        ref={datePickerRef}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",

          borderRadius: "8px",
        }}
      >
        <DatePicker
          selected={startDate}
          onChange={handleDateChange}
          startDate={startDate || undefined}
          endDate={endDate || undefined}
          selectsRange
          inline
          renderCustomHeader={({
            monthDate,
            changeMonth,
            decreaseMonth,
            increaseMonth,
            changeYear,
            decreaseYear,
            increaseYear,
          }: any) => (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "8px",
              }}
            >
              {/* Left Arrow for Year */}
              <button onClick={decreaseYear}>
                <img src={doubleArrowLeft} alt="arrowleft" />
              </button>
              {/* Left Arrow for Month */}
              <button onClick={decreaseMonth}>
                {" "}
                <img src={arrowLeft} alt="arrowleft" />{" "}
              </button>

              {/* Month and Year */}
              <span style={{ margin: "0 8px" }}>
                {monthDate.toLocaleString("default", { month: "long" })}
                {monthDate.getFullYear()}
              </span>

              {/* Right Arrow for Month */}
              <button onClick={increaseMonth}>
                {" "}
                <img src={arrowRight} alt="arrow left" />{" "}
              </button>

              {/* Right Arrow for Year */}
              <button onClick={increaseYear}>
                {" "}
                <img src={doubleArrowRight} alt="double arrow" />
              </button>
            </div>
          )}
          showMonthYearPicker={false} // Disable month/year dropdown
        />
      </Box>
    </div>
  );
}

export default DashboardDatePicker;
